













import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { synthEZDistributeScoreType } from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import BarDashed from '../../../_components/charts/BarDashed.vue'

  @Component({
    components: {
      BasePanel,
      BarDashed
    }
  })
export default class extends Vue {
    @Prop({}) private data!: any
    private mainData: any = {
      others: [],
      details: []
    }
    private colorList: any = []
    private barDataArray: Array < object > = []
    get type() {
      return this.$route.query.type
    }
    created() {
      if (!this.$route.query.searchParams) return
      let params = JSON.parse(this.$route.query.searchParams as string)
      synthEZDistributeScoreType({ ...params, energyZoneType: this.type }).then(res => {
        this.mainData = res.data.synthEZDistributeScoreType
        this.barDataArray = res.data.barChart || []
      })
      // let obj: any = this.data.pie
      // obj.HeightLastTypeIntro = obj.title
      // obj.data = []
      // this.data.pie.dataList.map(v => {
      //   obj.data.push({ name: v.name, value: v.value * 100 })
      // })
      // this.list.push(obj)
      // this.data.staminaHeightPercentVoLine.map(v => {
      //   this.list.push(v)
      // })
    }
}
